import { connect } from "react-redux";
import dispatchers from "ui/molecule/resetPassword/dispatchers";
import HomeUI from "ui/organism/Home/HomeUI";
import selectors from "ui/organism/Home/selectors";

// alebo takto temu mame v props export default withStyles(customStyles, { withTheme: true })(AddBabySitterUI);
export default connect(selectors, dispatchers)(HomeUI);
